'use client';

import { ContestHeader2026 } from '@/app-components/promotions/ContestHeader2026';
import { useResponsiveImageMap } from '@/ui-hooks/useResponsiveImageMap';
import { WebViewScreen } from '@diritto/common/app/webview-header.constant';
import { HELP_URL } from '@diritto/common/constants/url';
import { MutableHeaderLayout } from 'ui-components/layout/MutableHeaderLayout';
import { useInAppHeader } from 'ui-hooks/useInAppHeader';
import { useInAppStatusBar } from 'ui-hooks/useInAppStatusBar';
import { configure } from 'utils/configure';

const BASE_URL = `${configure.staticPrefix}/images/contests/4/vote`;
const HELP_QNA_URL = `${HELP_URL}/hc/ko/articles/14598106894991`;

export const ReviewPage = ({ isApp }: { isApp?: boolean }) => {
  useInAppHeader({ screen: WebViewScreen.PickAndChoo, title: '2026 제 4회 픽앤츄' });
  useInAppStatusBar(WebViewScreen.PickAndChoo);

  useResponsiveImageMap('image9', 'image-map9');

  return (
    <MutableHeaderLayout title="2026 제 4회 픽앤츄" noBottomPadding isApp={isApp}>
      <ContestHeader2026 tab="vote" />
      <div id="vote-page-container" className="flex flex-col items-center w-full bg-white">
        <div className="relative w-full flex justify-center">
          <img
            id="image9"
            useMap="#image-map9"
            alt="vote_2"
            src={`${BASE_URL}/1-2.webp`}
            className="w-full h-auto block"
          />
        </div>
      </div>

      <map name="image-map9">
        <area
          target="_blank"
          shape="rect"
          href={HELP_QNA_URL}
          coords="348,3302,1840,3667"
          title="프로그램 안내 및 상세 FAQ"
          alt="프로그램 안내 및 상세 FAQ"
        />
      </map>
    </MutableHeaderLayout>
  );
};
